<template>
  <div v-show="isActive">
    <slot></slot>
  </div>
</template>

<script>

export default {
  name: "igt-tab",
  props: {
    name: {required: true},
    selected: {default: false},
    visible: {default: true}
  },

  data() {
    return {
      canSelect: true,
      isActive: false
    };
  },

  computed: {
    href() {
      return '#' + this.name.toLowerCase().replace(/ /g, '-');
    }
  },

  mounted() {
    this.isActive = this.selected;
  }
}
</script>

<style scoped>

</style>
